// extracted by mini-css-extract-plugin
module.exports = {"dialogBox":"DialogBox_dialogBox__3y_0l","content":"DialogBox_content__UFqL7","closeBtn":"DialogBox_closeBtn__1IOj1"};